export const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 1280,
    xl: 1440,
    '2xl': 1920,
    '3xl': 2560,
} as const;

export type Breakpoint = keyof typeof breakpoints;

export const BREAKPOINT_COOKIE = 'screen_breakpoint';
export const TYPE_COOKIE = 'screen_type';
export const ONBOARDING_COOKIE = 'onboarding_completed';